// cancellation-policy-display.js — display-side data shaping for
// cancellation-policy renders. Mirrors the K1 server-side strict filter
// so frontend (App.jsx PolicyCard, plain-text email composer) and
// backend (manage.js, confirm.js, _helpers.js policyHtml) all behave
// identically: hide-if-empty, no synthesis fallback, no fake tiers.

/**
 * Returns valid policy tiers — strict filter on Number.isFinite for both
 * hoursBeforeFlight + refundPct, sorted descending by hoursBeforeFlight.
 *
 * Aircraft without a Sanity cancellationPolicy ref → returns [].
 * Callers MUST hide the policy block entirely when length === 0; do
 * NOT synthesize fake tiers.
 *
 * @param {object|null|undefined} policy
 * @returns {Array} valid tiers, possibly empty (NEVER returns synthesized tiers)
 */
export function getValidPolicyTiers(policy) {
  if (!policy?.tiers || !Array.isArray(policy.tiers)) return [];
  return policy.tiers
    .filter(t => Number.isFinite(t.hoursBeforeFlight) && Number.isFinite(t.refundPct))
    .sort((a, b) => b.hoursBeforeFlight - a.hoursBeforeFlight);
}
